import { pageQueryParams } from '@/components/search/pageQueryParams'
import { SortableHeader } from '@/components/search/SortableHeader'
import React, { useEffect, useRef, useState } from 'react'
import { Services } from '@/services/services';
import { SuperAdminEditMachineForm, SuperAdminInsertMachineForm, MachineFormData } from '@/components/forms/machines/Machine';
import { CurrentSession, SessionService } from '@/services/repository/session';
import { LoggedInPageLayout } from '@/components/layout/LoggedInLayout';
import { PageQuery, PageResponse, SearchTable, SearchTableParams, SearchTableRef } from '@/components/search/SearchTable';
import { formatDate } from '@/common/time';
import { useNavigate } from 'react-router-dom';
import { useModal } from '@/components/modal/Modal';
import { BackButton } from '@/components/layout/NavBar';
import './Questions.css'

export interface SupportQuestion {
  id: string;
  category: string;
  issue: string;
  user?: string;
  content: string;
  email: string;
  phoneNumber?: string;
  createdAt?: string;
}

export interface FileInfo {
  id: string;
  url: string;
}

export interface SimpleSupportQuestionRowDTO {
  row: SupportQuestion;
  files: FileInfo[];
}

export interface SimpleSupportQuestion extends SupportQuestion { }

export interface SuperAdminViewSupportQuestionPopupProps {
  services: Services,
  session: CurrentSession,
  onClose: () => void,
  id: string
  // onInsert?: (data: { id: string, qr: string }) => void
}

export const SuperAdminViewSupportQuestionPopup = ({ services, session, onClose, id }: SuperAdminViewSupportQuestionPopupProps) => {
  const [row, setRow] = useState<SimpleSupportQuestionRowDTO>()
  const [error, setError] = useState<boolean>(false)

  useEffect(() => {
    services.session.fetchWithToken(`/api/superadmin/support/questions/byid/${id}`, {
      method: 'GET'
    }).then(async (r) => {
      if (r.status !== 200) {
        const erros = await r.json()
        setError(true)
        return
      }
      setRow(await r.json())
    })
  }, [id])

  if (row === undefined) {
    return <div className='spinner'></div>
  }

  if (error) {
    return <div className='critic-error-box'>
      {session.translates.for('errors.general_error')}
    </div>
  }

  const { row: question, files } = row;

  return <div className='support-question-details-modal'>

    {/* <div><strong>ID:</strong> {question.id}</div> */}
    <div><strong>{session.translates.for('forms.support_questions.fields.category.title')}:</strong> {session.translates.for(`wizards.support_question.categories.${question.category}`)}</div>
    <div><strong>{session.translates.for('forms.support_questions.fields.issue.title')}:</strong> {session.translates.for(`wizards.support_question.category.${question.category}.${question.issue}`)}</div>
    {/* <div><strong>User:</strong> {question.user || '-'}</div> */}
    <div><strong>{session.translates.for('forms.support_questions.fields.email.title')}:</strong> {question.email}</div>
    <div><strong>{session.translates.for('forms.support_questions.fields.phone_number.title')}:</strong> {question.phoneNumber || '-'}</div>
    <div><strong>{session.translates.for('forms.support_questions.fields.created_at.title')}:</strong> {question.createdAt ? formatDate(new Date(question.createdAt)) : '-'}</div>
    <div><strong>{session.translates.for('forms.support_questions.fields.content.title')}:</strong> <pre>{question.content}</pre></div>

    {files && files.length > 0 && (
      <div>
        <strong>{session.translates.for('forms.support_questions.fields.attached_files.title')}:</strong>
        <ul>
          {files.map((file) => (
            <li key={file.id}>
              <a href={file.url} rel="noopener noreferrer">{file.id}</a>
            </li>
          ))}
        </ul>
      </div>
    )}

    {error ? <div className='critic-error-box'>{session.translates.for('errors.general_error')}</div> : ''}
  </div>
}

export const SuperAdminSupportQuestionPage = ({ services, session }: { services: Services, session: CurrentSession }) => {
  const searchTableRef = useRef<SearchTableRef>(null)
  const navigate = useNavigate()
  const { openModal } = useModal()

  // useResponsiveChange()

  const openDetails = (id: string) => openModal((props) => SuperAdminViewSupportQuestionPopup({ ...props, id, services, session }))

  const tableParams: SearchTableParams<SimpleSupportQuestion> = {
    fetch: (q: PageQuery): Promise<PageResponse<SimpleSupportQuestion>> => {
      return services.session.fetchWithToken(`/api/superadmin/support/questions/search?${pageQueryParams(q)}`).then((r) => {
        if (r.status === 200) {
          return r.json()
        }
        return Promise.reject()
      })
    },
    pageQuery: {
      pageNumber: 1,
      pageSize: 30,
      search: ""
    },
    defaultSortBy: 'category',
    header: (query, onSort) => <>
      {/* {isDesktopScreen() && <div className='hcol '>{session.translates.for('elements.table.support_question.createdAt')}</div>}
      {isDesktopScreen() && <div className='hcol'>{session.translates.for('elements.table.support_question.imei')}</div>} */}
      <SortableHeader field='category' query={query} onSort={onSort}>{session.translates.for('elements.table.support_question.category')}</SortableHeader>
      <SortableHeader field='issue' query={query} onSort={onSort}>{session.translates.for('elements.table.support_question.issue')}</SortableHeader>
      <SortableHeader field='createdAt' query={query} onSort={onSort}>{session.translates.for('elements.table.support_question.created_at')}</SortableHeader>
      {/* <div className='hcol'></div>
      <div className='hcol'></div>
      <div className='hcol'></div>
      <div className='hcol'></div> */}
    </>,
    row: (row) => <>
      {/* {isDesktopScreen() && <div className='col'>{formatDate(new Date(row.createdAt))}</div>}
      {isDesktopScreen() && <div className='col'>{row.imei}</div>} */}
      <div className='col' onClick={() => openDetails(row.id)}>{session.translates.for(`wizards.support_question.categories.${row.category}`)}</div>
      <div className='col' onClick={() => openDetails(row.id)}>{session.translates.for(`wizards.support_question.category.${row.category}.${row.issue}`)}</div>
      <div className='col' onClick={() => openDetails(row.id)}>{row.createdAt ? formatDate(new Date(row.createdAt)) : '-'}</div>
      {/* <div className='col icocol' onClick={() => navigate(`/communal/machine/${row.id}`)}>
        <i className='svgfont-link' />
      </div>
      <div className='col icocol' onClick={() => openModal((props) => CardHistoryBody({ ...props, machineId: row.id, services, session }))}>
        <i className='svgfont-user-card' />
      </div>
      <div className='col icocol' onClick={() => openModal((props) => MachinePopupQRCodeBody({ ...props, machineId: row.id, services, session, translates: session.translates }))}>
        <i className='svgfont-qrcode' />
      </div>
      <div className='col icocol' onClick={() => row.machineTypeId && openModal((props) => MachinePopupDocBody({ ...props, machineTypeId: row.machineTypeId, services, session, translates: session.translates }))} >
        {row.machineTypeId ? <i className='svgfont-documentation' /> : '-'}
      </div>
      {/* <div className='col icocol' onClick={() => openModal((props) => RelatedUsersPage({...props, machineId: row.id, services, session}))}>
        <i className='svgfont-user' />
      </div> 
      <div className='col icocol' onClick={() => openModal((props) => SuperAdminMachineMapPopup({ ...props, imei: row.imei, services, session }))}>
        <i className='svgfont-map' />
      </div> */}
      {/* <div className='col icocol' onClick={() => openModal((props) => SuperAdminEditMachinesPopup({ ...props, machineId: row.id, services, session }))}>
        <i className='svgfont-edit' />
      </div> */}
    </>,
    translates: session.translates
  }

  return <LoggedInPageLayout pageName='superadmin-questions' services={services} session={session}
    navbarLeft={<BackButton services={services} translates={session.translates} />}>
    <SearchTable ref={searchTableRef} {...tableParams} />
    {/* <SuperAdminEditMachinesPopup id={edited} onClose={() => setEdited(undefined)} services={services} session={session} />
    <RelatedUsersPage machineId={editUsers} onClose={() => setEditUsers(undefined)} services={services} session={session} />
    <SuperAdminInsertMachinesPopup isOpen={inserted} onClose={() => setInserted(false)} services={services} session={session} /> */}

    {/* <Modal isOpen={docsType !== undefined} onClose={() => { setDocType(undefined) }} >
      <MachinePopupDocBody machineTypeId={docsType} services={services} session={session} translates={session.translates} />
    </Modal>
    <Modal isOpen={qrPopup !== undefined} onClose={() => { setQRPopup(undefined) }} >
      <MachinePopupQRCodeBody machineId={qrPopup} services={services} session={session} translates={session.translates} />
    </Modal> */}
  </LoggedInPageLayout>
}
